export default __webpack_public_path__ + "img/f72af746753110a8ec50cfa582ce0a8d.png";